import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "./SpacerStyles";

export default class Spacer extends Component {
  render() {
    return <div className={css(styles.spacer)}></div>;
  }
}
